/* Plantilla de product page de Cilloniz Ecom (cpt).
   Galería, selector de packs sincronizado con Releasit por índice, y botones que abren el formulario COD.
   Botón fijo, regalo y antes/después (30-sep-2026). El único MutationObserver vive mientras se abre el formulario
   y se corta a los 6 s; el IntersectionObserver del botón fijo solo compara y cambia un atributo. */
(function () {
  'use strict';
  var RSI_BTN = '._rsi-buy-now-button';
  var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open';
  var RSI_OFFER = '._rsi-quantity-offers-offer-container';
  var RSI_SEL = '_rsi-quantity-offers-selected';

  /* ---------- galería ---------- */
  function galeria(root) {
    var track = root.querySelector('.cpt-slides');
    var thumbs = root.querySelectorAll('.cpt-thumb');
    if (!track || !thumbs.length) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
    });
    var last = -1, pending = false;
    track.addEventListener('scroll', function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === last) return; last = i;
        thumbs.forEach(function (t, k) { var v = String(k === i); if (t.getAttribute('aria-current') !== v) t.setAttribute('aria-current', v); });
      });
    }, { passive: true });
    autoPasar(root, track, thumbs.length);
  }

  /* La galería pasa sola (10-oct-2026). Se detiene para siempre en cuanto el cliente la toca, la desliza o elige una
     miniatura (no se le pelea el control), se pausa fuera de pantalla o con la pestaña oculta, y no corre con
     "reducir movimiento". Un solo temporizador por galería. */
  function autoPasar(root, track, n) {
    if (root.dataset.auto !== 'true' || n < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ms = Math.max(2, parseInt(root.dataset.seg, 10) || 4) * 1000;
    var timer = null, visible = true, parado = false;
    function siguiente() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      track.scrollTo({ left: ((i + 1) % n) * track.clientWidth, behavior: 'smooth' });
    }
    function arrancar() { if (!timer && !parado && visible && !document.hidden) timer = setInterval(siguiente, ms); }
    function pausar() { if (timer) { clearInterval(timer); timer = null; } }
    function parar() { parado = true; pausar(); }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { root.addEventListener(ev, parar, { passive: true }); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pausar(); else arrancar(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) arrancar(); else pausar(); },
        { threshold: 0.5 }).observe(track);
    }
    arrancar();
  }

  /* ---------- packs ---------- */
  window.CPT_IDX = 0;
  function elegirPack(idx) {
    idx = parseInt(idx, 10) || 0;
    window.CPT_IDX = idx;
    document.querySelectorAll('.cpt-pack[data-idx]').forEach(function (p) {
      var v = String(parseInt(p.dataset.idx, 10) === idx);
      if (p.getAttribute('aria-checked') !== v) p.setAttribute('aria-checked', v);
    });
    var sel = document.querySelector('.cpt-most .cpt-pack[aria-checked="true"]');
    var label = sel ? sel.dataset.precio : '';
    var titulo = sel ? (sel.dataset.titulo || '') : '';
    document.querySelectorAll('[data-cpt-precio-cta]').forEach(function (e) { if (label && e.textContent !== label) e.textContent = label; });
    document.querySelectorAll('[data-cpt-titulo-cta]').forEach(function (e) { if (e.textContent !== titulo) e.textContent = titulo; });
    // regalo: se marca como incluido solo si el pack elegido lo trae
    var con = !!(sel && sel.dataset.regalo === '1');
    document.querySelectorAll('[data-cpt-regalo]').forEach(function (r) {
      if (r.classList.contains('on') !== con) r.classList.toggle('on', con);
      var est = r.querySelector('.cpt-regalo-estado');
      if (est) { var txt = con ? est.dataset.si : est.dataset.no; if (txt && est.textContent !== txt) est.textContent = txt; }
    });
  }

  /* ---------- botón fijo: visible cuando el botón principal ya salió por arriba ---------- */
  function botonFijo() {
    var fijo = document.querySelector('[data-cpt-fijo]');
    var ancla = document.querySelector('.cpt-most .cpt-form');
    if (!fijo || !ancla || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      var e = es[0];
      // Releasit trae su propio botón fijo: si la tienda lo tiene activo, el de la plantilla no se muestra (no dos barras)
      var releasit = !!document.querySelector('._rsi-buy-now-button-floating');
      var ver = !releasit && !e.isIntersecting && e.boundingClientRect.top < 0;
      if (fijo.hidden === ver) fijo.hidden = !ver;
      if (document.body.classList.contains('cpt-con-fijo') !== ver) document.body.classList.toggle('cpt-con-fijo', ver);
    });
    io.observe(ancla);
  }

  /* ---------- antes y después: el rango mueve la línea ---------- */
  function antesDespues() {
    document.querySelectorAll('[data-cpt-ba]').forEach(function (ba) {
      var r = ba.querySelector('.cpt-ba-rango');
      if (!r) return;
      r.addEventListener('input', function () { ba.style.setProperty('--cpt-ba', r.value + '%'); });
    });
  }
  window.cptElegirPack = elegirPack;

  /* ---------- Releasit: preseleccionar la misma oferta dentro de su formulario ---------- */
  var sincronizando = false;
  function sincronizarReleasit() {
    if (sincronizando) return; sincronizando = true;
    var t0 = Date.now(), listo = false, mo = null, clics = 0, ultimo = 0;
    function fin() { listo = true; sincronizando = false; if (mo) { mo.disconnect(); mo = null; } }
    function aplicar() {
      if (listo) return true;
      if (!document.querySelector(RSI_MODAL)) return false;
      var ofertas = document.querySelectorAll(RSI_OFFER); if (!ofertas.length) return false;
      var el = ofertas[window.CPT_IDX | 0]; if (!el) { fin(); return true; }
      if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { fin(); return true; }
      var blanco = el.querySelector('._rsi-quantity-offers-offer') || el;
      if (clics < 6 && Date.now() - ultimo > 250) { clics++; ultimo = Date.now(); try { blanco.click(); } catch (e) {} }
      return false;
    }
    if (aplicar()) return;
    if (window.MutationObserver) {
      mo = new MutationObserver(function () { if (aplicar()) return; if (Date.now() - t0 > 6000) fin(); });
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    var poll = setInterval(function () { if (aplicar() || Date.now() - t0 > 6000) { clearInterval(poll); fin(); } }, 300);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(RSI_BTN)) sincronizarReleasit();
  }, true);

  /* ---------- botones de la página que abren el formulario ---------- */
  function abrirFormulario() {
    var btn = document.querySelector('.cpt-most ' + RSI_BTN) || document.querySelector(RSI_BTN);
    if (btn) { btn.click(); return; }
    var form = document.querySelector('.cpt-form');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var atc = form.querySelector('.cpt-atc'); if (atc) setTimeout(function () { atc.focus(); }, 500);
    }
  }
  document.addEventListener('click', function (e) {
    var pack = e.target.closest && e.target.closest('.cpt-pack[data-idx]');
    if (pack) { e.preventDefault(); elegirPack(pack.dataset.idx); if (pack.hasAttribute('data-cpt-abrir')) abrirFormulario(); return; }
    var cta = e.target.closest && e.target.closest('[data-cpt-cta]');
    if (cta) { e.preventDefault(); abrirFormulario(); }
  });

  // Videos de la página: se descargan y reproducen recién al acercarse (preload="none" + data-cpt-src)
  function videos() {
    var vs = document.querySelectorAll('video[data-cpt-src]');
    if (!vs.length) return;
    function cargar(v) { if (!v.src) v.src = v.getAttribute('data-cpt-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vs.forEach(cargar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) cargar(e.target); else if (e.target.src) e.target.pause(); });
    }, { rootMargin: '300px 0px' });
    vs.forEach(function (v) { io.observe(v); });
  }

  function iniciar() {
    videos();
    botonFijo();
    antesDespues();
    document.querySelectorAll('.cpt-gal').forEach(galeria);
    var pre = document.querySelector('.cpt-most .cpt-pack[data-pre="true"]') || document.querySelector('.cpt-pack[data-pre="true"]');
    elegirPack(pre ? pre.dataset.idx : 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
